import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: 'fa',
	},
	theme: {
		themes: {

			light: {
				primary: '#0b7078',
				secondary: '#3d2645',
				accent: '#4ca0a7'
			}
		}
	}
});
